module.exports = __webpack_public_path__ + "img/boe.d1b7db09.png";